import { render, staticRenderFns } from "./size-chart.vue?vue&type=template&id=1a40301e&"
import script from "./size-chart.vue?vue&type=script&lang=js&"
export * from "./size-chart.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports